import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// @ts-ignore
import styled from "./MenuUserActionSection.module.css";
import Profile from "../profile/Profile";
import LocalSwitcher from "../LocalSwitcher/LocalSwitcher";
import NotificationBell from "../NotificationBell/NotificationBell";
import BirthdayBell from "../BirthdayBell/BirthdayBell";
// 051: el botón de Adri reemplaza al enlace de WhatsApp "¿Necesitas ayuda?"
import AdriHeaderButton from "../../../adri/components/AdriHeaderButton/AdriHeaderButton";
// 010: gating del tenant HQ de Prikly (bandeja de soporte)
import { getHqAccess } from "../../../support/services/supportApi";

const MenuUserActionSection = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [isHq, setIsHq] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Solo el tenant configurado en SUPPORT_HQ_COMPANY_ID recibe true
    getHqAccess().then(setIsHq);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <article
      className={styled.menuUserActionSection__article}
      data-testid="menuUserActionSection-article"
    >
      <LocalSwitcher />
      <NotificationBell />
      <BirthdayBell />
      {isHq && (
        <button
          onClick={() => navigate("/soporte-hq")}
          title="Soporte Prikly (HQ)"
          aria-label="Bandeja de soporte de Prikly"
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: "18px",
            padding: "4px 6px",
          }}
        >
          🛟
        </button>
      )}
      <AdriHeaderButton />
      <Profile width={screenWidth} />
    </article>
  );
};

export default MenuUserActionSection;
